import { getType, getActionCreator } from 'shared/lib';
const prefix = '@@app/ModalContainer';

export const OPEN_MODAL = getType(prefix, 'OPEN_MODAL');
export const openModal = getActionCreator(OPEN_MODAL);

export const CLOSE_MODAL = getType(prefix, 'CLOSE_MODAL');
export const closeModal = getActionCreator(CLOSE_MODAL);
